import _ from "lodash";

export const STATUS_OK = 204;
/**
 * Find object in array of objects
 * @param {array} data of objects es: [{ name: "Description", v: "{ 'Machine_Id': 'aaa' }"}]
 * @param {object} search es: { ..., v: { 'Machine_Id': 'aaa' } }
 **/
export function findValueInSearch(data, search) {
  return _.some(data, o => o.v === search.v);
}

/**
 * Return Availability perc (%): GREEN+YELLOW / GREEN+YELLOW+RED
 * @param {object} status { "green": "", "yellow": "", "red": "" }
 **/
export function calculateAvailabilityPerc(pub) {
  // --- AVAILABILITY from API ---
  const _data = {};

  _.forEach(["FAIL", "EXE", "READY", "HANDLING"], function (k) {
    _data[k] = Math.floor(Number(pub[k])) || 0; // campi mancanti valgono zero
  });

  const availabilityValue =
    _data["EXE"] > 0 || _data["FAIL"] > 0 || _data["READY"] > 0 || _data["HANDLING"] > 0
      ? Math.round(
          ((Number(_data["EXE"]) + Number(_data["READY"]) + Number(_data["HANDLING"])) /
            (Number(_data["EXE"]) +
              Number(_data["READY"]) +
              Number(_data["HANDLING"]) +
              Number(_data["FAIL"]))) *
            100
        )
      : 0;
  const res = {
    perc: availabilityValue,
    class: availabilityValue > 50 ? "up" : "down"
  };
  return res;
}

/**
 * Return Efficiency perc: GREEN / GREEN+RED
 * @param {object} status { "green": "", "red": "" }
 **/
export function calculateEfficiencyPerc(pub) {
  // --- EFFICIENCY from API ---
  const _data = {};

  _.forEach(["FAIL", "EXE", "READY"], function (k) {
    _data[k] = Math.floor(Number(pub[k])) || 0; // campi mancanti valgono zero
  });

  const efficiencyValue =
    _data["EXE"] > 0 || _data["FAIL"] > 0
      ? Math.round((Number(_data["EXE"]) / (Number(_data["EXE"]) + Number(_data["FAIL"]))) * 100)
      : 0;

  const res = {
    perc: efficiencyValue,
    class: efficiencyValue > 50 ? "up" : "down"
  };

  return res;
}

/**
 * Wrap aggregate status machine
 * @param {object} pub
 */
export function wrapPubAggregateStatus(pubData) {
  /*
      // Old model
      {
        "v":   {
          "status":     {
            "yellow": 7597,
            "green": 22346,
            "red": 907
          },
          "timestamp": "2018-12-03T08:34:04.453Z"
        },
        "ttl": 1543881599,
        "ts": "2018-12-03T08:34:04.453Z"
      }
      // New model
      {
        "v":   {
          "grey": 11793,
          "yellow": "19140"
        },
        "ts": "2018-12-03T08:37:47.045Z"
        "timestamp": "2018-12-03T08:34:04.453Z"
      }
      */

  const ret = {
    v: {},
    ts: ""
  };
  try {
    if (pubData.v.status) {
      ret.v = pubData.v.status;
      ret.ts = pubData.v.timestamp;
    } else {
      ret.v = pubData.v;
      // N.B. Timestamp Valore corretto / ts solo per vecchie msim
      ret.ts = pubData.timestamp ? pubData.timestamp : pubData.ts;
    }

    if (ret.v) {
      for (const key in ret.v) {
        ret.v[key] = Math.floor(Number(ret.v[key]));
      }
    }

    return ret;
  } catch (e) {
    return null;
  }
}

const _setDate = (date, days) => {
  return new Date().setDate(date.getDate() - days);
};

/**
 * Get start date selection on WEEK, MONTH, YEAR
 * @param {string} selector
 */
export function selectorToDate(selector, from) {
  let ret = from || new Date();
  switch (selector) {
    case "day":
      ret.setHours(0);
      ret.setMinutes(0);
      ret.setSeconds(0);
      break;
    case "week":
      ret = _setDate(ret, 7);
      break;
    case "month":
      ret = _setDate(ret, 31);
      break;
    case "year":
      ret = _setDate(ret, 365);
      break;
    default: {
      throw Error("wrong selector in some day/week/month/year based channel");
    }
  }
  return ret;
}

export function previousDay() {
  const yesterday = new Date();
  yesterday.setHours(23);
  yesterday.setMinutes(59);
  yesterday.setSeconds(59);
  return _setDate(yesterday, 1);
}

/*
 * Remove duplicate entry from array of objects bu prop
 * @param Array myArr
 * @param String prop
 */
export function removeDuplicates(myArr, prop) {
  const res = myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
  return res;
}

/**
 * Get percent on amount
 * @param {String} val
 * @param {String} amount
 */
export const getPercAmount = function (val, amount) {
  try {
    return (val / amount) * 100;
  } catch (e) {
    console.error(e);
  }
};

export const sortArray = (elements, field, asc = true) => {
  return (elements || []).sort((a, b) => {
    const fieldA = ((typeof a === "object" && a && a[field]) || a || "").toUpperCase();
    const fieldB = ((typeof b === "object" && b && b[field]) || b || "").toUpperCase();

    if (fieldA < fieldB) {
      return asc ? -1 : 1;
    }
    if (fieldA > fieldB) {
      return asc ? 1 : -1;
    }

    return 0;
  });
};
